import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { TIconColor } from 'src/app/project/components/icon/icon-colors.model';
import { logEventInGTAG } from 'src/app/project/services/analytics/google-analytics';
import {
  EGoogleEventCategory,
  EGoogleEventSavedViews,
} from 'src/app/project/services/analytics/google-analytics.consts';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { QuickFilterService } from '../../../filters/filters-api/search/quick-filter-service';
import { EUserRole } from '../../../share/share-utils/user-roles';
import { TableColumnsService } from '../../../site/site-table/columns/table-columns.service';
import { GET_COLLAPSED_GROUPS } from '../../../site/site-table/table.ui.store';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { ESavedView } from '../../models/saved-view.enum';
import { TSavedView } from '../../models/saved-view.model';
import { SavedViewsService } from '../../saved-views.service';

@Component({
  selector: 'pp-saved-views-dropdown-new-view-button',
  templateUrl: './saved-views-dropdown-new-view-button.component.html',
  styleUrls: ['./saved-views-dropdown-new-view-button.component.scss'],
  standalone: false,
})
export class SavedViewsDropdownNewViewButtonComponent implements OnDestroy, OnChanges {
  @Input() ppWorkspaceId: string;
  @Input() ppType: ESavedView;

  private readonly destroy$ = new Subject<void>();

  EIconPath = EIconPath;
  hidden: boolean;

  iconColour: TIconColor = 'primary-600';

  constructor(
    private tableColumnsService: TableColumnsService,
    private savedViewsService: SavedViewsService,
    private workspaceService: WorkspaceService,
    private quickFilterService: QuickFilterService,
  ) {}

  ngOnChanges(): void {
    this.checkShowCreateButton();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  checkShowCreateButton(): void {
    const workspaceData = this.workspaceService.getWorkspace(this.ppWorkspaceId);

    if (!workspaceData) {
      this.hidden = false;
      return;
    }

    const userType = workspaceData.share.shareOption;

    if (
      userType !== EUserRole.ACCOUNT_ADMIN &&
      userType !== EUserRole.SITE_ADMIN &&
      userType !== EUserRole.OWNER &&
      this.ppType === ESavedView.SHARED
    ) {
      this.hidden = true;
    } else {
      this.hidden = false;
    }
  }

  createView(): void {
    const columns = this.tableColumnsService.getColumns();

    const newView: Partial<TSavedView> = {
      name: 'New View',
      quickFilters: {
        quick: this.quickFilterService.getFilters().quick,
        advanced: {
          filters: this.quickFilterService.getFilters().advanced,
          operator: this.quickFilterService.getFilters().operator,
        },
      },
      columns,
      viewType: this.ppType,
      collapsedGroups: Array.from(GET_COLLAPSED_GROUPS()),
    };

    logEventInGTAG(EGoogleEventSavedViews.CREATE_SAVED_VIEW, {
      source: EGoogleEventCategory.SAVED_VIEWS,
      type: this.ppType,
    });

    this.savedViewsService.createView(newView, this.ppWorkspaceId).subscribe();
  }
}
